module.exports = __webpack_public_path__ + "static/media/account-deleted-1.16ff19ca.png";